import {
    booleanAttribute,
    Component,
    inject,
    input,
    Input,
} from '@angular/core';
import {
    ControlContainer,
    FormControl,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import {
    InputElementModel,
    InputHTMLTypes,
} from '../../../models/clientsform/input-element-model';
import { LocalizationService } from '../../../services/localization.service';
import { TranslationComponent } from '../../translation/translation.component';

@Component({
    selector: 'apcam-input-element',
    imports: [
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslatePipe,
        TranslationComponent,
    ],
    templateUrl: './input-element.component.html',
    styleUrl: './input-element.component.scss',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: () => inject(ControlContainer, { skipSelf: true }),
        },
    ],
})
export class InputElementComponent {
    @Input({ required: true })
    public formcontrolName!: string;

    @Input({ required: true })
    public inputConfig!: InputElementModel;

    @Input()
    public disabled: boolean = false;

    public readonly showPlaceholder = input(true, {
        transform: booleanAttribute,
    });

    protected get currentLang() {
        return this.localizationService.getCurrentLanguage();
    }

    protected get placeholderText(): string {
        return this.showPlaceholder()
            ? this.inputConfig.placeholder.translations[this.currentLang]
            : '';
    }

    protected get input(): FormControl {
        return this.controlContainer.control?.get([
            this.formcontrolName,
        ]) as FormControl;
    }

    protected readonly InputHTMLTypes = InputHTMLTypes;

    private readonly controlContainer = inject(ControlContainer);
    private readonly localizationService = inject(LocalizationService);
}
